import { gql } from "@apollo/client";

const GET_BOOKING =
  gql(`query BookingUser ($eventId: ID, $bookingSessionId: ID) {
  bookingUser (eventId: $eventId, bookingSessionId: $bookingSessionId) {
    id
    duration createdAt bookedHour bookedDate
    numberOfGuests
    clientStatus
    requestedArea { id name }
    organizer {
      lastName
      username
      firstName
      id
      account { phone email }
    }
    smsMessages { type body to status sentAt statusAt }
    paymentRequest { id amount total currency emailRequired createdAt }
    orders { id total commission discount currency items { type name quantity price } }
    organizerId
    status
    eventId
    tables {
      area {
        name
      }
      name
    }
    linkedEvent {
      id
      name
      startDate
      endDate
      images
      subCategory {
        name
      }
    }
  }
}`);

const GET_BOOKINGS_FOR_CALENDAR_BY_ID_AND_DATE =
  gql(`query BookingModule($bookingModuleId: ID!, $date: DateTime) {
    bookingModule(id: $bookingModuleId, date: $date) {
      id
      areas {
        id
        name
        tables {
          capacity
          description
          id
          name
          bookedSessions {
            bookedDate
            id
            bookedHour
            createdAt
            duration
            eventId
            numberOfGuests
            description
            phoneBookEntry { id name firstName lastName email phone comments reservationsCount  eventReservationsCount eventUnapprovedCount tags { id name } }
            smsMessages { type body to status sentAt statusAt }
            organizer {
              firstName
              account {
                email
                id
                phone
                accountType
              }
              id
              lastName
              username
              avatar
            }
            organizerId
            status
            clientStatus
            visitsCount
            unapprovedCount
            specialOccasions {
              id
              name
            }
            dietaryRestrictions {
              id
              name
            }
            tableRequirements {
              id
              name
            }
            clientTags {
              id
              name
            }
          }
        }
      }
      sessions {
            bookedDate
            id
            bookedHour
            createdAt
            duration
            eventId
            numberOfGuests
            description
            phoneBookEntry { id name firstName lastName email phone comments reservationsCount  eventReservationsCount eventUnapprovedCount tags { id name } }
            smsMessages { type body to status sentAt statusAt }
            organizer {
              firstName
              account {
                email
                id
                phone
                accountType
              }
              id
              lastName
              username
              avatar
            }
            organizerId
            status
            clientStatus
            visitsCount
            unapprovedCount
            specialOccasions {
              id
              name
            }
            dietaryRestrictions {
              id
              name
            }
            tableRequirements {
              id
              name
            }
            clientTags {
              id
              name
            }
            requestedArea {
              id
              name
            }
            tables {
              id
              name
            }
      }
      pauses {
        id
        startDate
        endDate
        description
        area {
          id
          name
        }
      }
      openingHours
      holdingFee
      enabledWaitlist
      enabledPaymentRequest
      bookingInterval
      bookingDuration
      isBookableUnit
      maxGuests
      minGuests
      maxBookingGuests
      minBookingGuests
      event {
        general {
          openingHours
          name
          startDate
          endDate
          isPermanent
          id
          openingHours
        }
        booking {
          bookingInterval
        }
      }
      specialOccasions {
        id
        name
      }
      dietaryRestrictions {
        id
        name
      }
      tableRequirements {
        id
        name
      }
      clientTags {
        id
        name
      }  
    }
  }`);

const GET_ALL_RESERVATIONS = gql(`
  query BookingModule($bookingModuleId: ID!) {
  bookingModule(id: $bookingModuleId) {
    sessions {
      bookedDate
      bookedHour
      createdAt
      eventId
      id
      duration
      description
      phoneBookEntry { id name firstName lastName email phone comments reservationsCount  eventReservationsCount eventUnapprovedCount tags { id name } }
      smsMessages { type body to status sentAt statusAt }
      organizer {
        lastName
        firstName
        account {
          phone
          email
        }
      }
      status
      clientStatus
      numberOfGuests
      tables {
        area {
          name
          id
        }
        name
        id
        capacity
      }
      specialOccasions {
        id
        name
      }
      dietaryRestrictions {
        id
        name
      }
      tableRequirements {
        id
        name
      }
      clientTags {
        id
        name
      }
      requestedArea {
        id
        name
      }
    }
    isBookableUnit
    maxGuests
    minGuests
    maxBookingGuests
    minBookingGuests
    areas {
        id
        name
    }
  }
}
  `);

const GET_RESERVATION_ID = gql(`
  query ReservationId($shortCode: String!) {
    reservationId(shortCode: $shortCode)
  }
  `)

const GET_MENU_CATEGORIES = gql(`
query MenuCategories {
  menuCategories {
    orderIndex
    nameRo
    nameEn
    key
    id
  }
}
  `);

export const CLIENT_TAGS = gql`
  query ClientTags { clientTags { id name } }
`;

export const RESERVATION_PAYMENT_INFO = gql(`
  query ReservationPaymentInfo($id: ID!) {
    reservation(id: $id) { id status suggestedPaymentAmount paymentRequest { id amount total currency emailRequired createdAt } }
  }`);

export {
  GET_BOOKING,
  GET_BOOKINGS_FOR_CALENDAR_BY_ID_AND_DATE,
  GET_ALL_RESERVATIONS,
  GET_MENU_CATEGORIES,
  GET_RESERVATION_ID,
};
